export const NORTH = 'NORTH';
export const EAST = 'EAST';
export const SOUTH = 'SOUTH';
export const WEST = 'WEST';

export const POSITIONS = [SOUTH, WEST, NORTH, EAST,];
export const HTML_POSITIONS = [NORTH, WEST, EAST, SOUTH,];